<script>
  import { getContext } from "svelte"
  import FetchTransactions from "./FetchTransactions.svelte"
  import {
    useOperationTableStylesQuery
  } from "../../../../../hooks/project/views/operationTable/useOperationTableStylesQuery.js";
  import {
    useOperationTableStyleDetailsQuery
  } from "../../../../../hooks/project/views/operationTable/useOperationTableStyleDetailsQuery.js";
  import {
    useOperationTablePropertyDefsQuery
  } from "../../../../../hooks/project/views/operationTable/useOperationTablePropertyDefsQuery.js";
  import EnsureFetchedQueries from "../../../../functional/EnsureFetchedQueries.svelte";

  // props
  /**
   * @type {string}
   */
  export let projectId

  /**
   * This prop will determine at what interval the data will be refetched.
   * Set this to "false" to disable refetching, or provide refetching interval in milliseconds.
   * @type {false|number}
   */
  export let refetchInterval = false

  export let OperationTableStore

  const {
    StyleIndex,
    Styles,
  } = OperationTableStore

  // error handlers
  const {handleFetchErrors} = getContext("fetchErrorHandler")

  // svelte-query
  const stylesQueryResult = useOperationTableStylesQuery(projectId, handleFetchErrors, refetchInterval)
  stylesQueryResult.subscribe(val => {
    if (val.data) Styles.set(val.data)
  })
  $: styleDetailsQueryResult = useOperationTableStyleDetailsQuery(projectId, $StyleIndex, handleFetchErrors, refetchInterval)
  const propertyDefsQueryResult = useOperationTablePropertyDefsQuery(projectId, handleFetchErrors, refetchInterval)

  $: lastDownloadedTimeStamp = $styleDetailsQueryResult.data?.[5] ?? null
</script>

<FetchTransactions
  projectId={projectId}
  downloadTimestamp={lastDownloadedTimeStamp}
  refetchInterval={refetchInterval}
  enabled={lastDownloadedTimeStamp !== null}
  let:transactions
  let:reloadTransactions
  let:resetTransactions
  let:isInputAllowed
>
  <EnsureFetchedQueries
    queries={[
      $stylesQueryResult,
      $styleDetailsQueryResult,
      $propertyDefsQueryResult,
    ]}
  >
    <slot
      projectId={projectId}
      styles={$stylesQueryResult.data}
      operationsData={$styleDetailsQueryResult.data}
      propertyDefsData={$propertyDefsQueryResult.data}
      transactions={transactions}
      reloadTransactions={reloadTransactions}
      resetTransactions={resetTransactions}
      isInputAllowed={isInputAllowed}
    />
  </EnsureFetchedQueries>
</FetchTransactions>
